module.exports = __webpack_public_path__ + "img/Pista_3517.ad880cf0.png";